import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

// models
import { ISkillDuplicate } from '../models/skill.duplicate.model';
// services

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable()
export class SkillDuplicatesService {
  private endpoint = '/api/Tracks';

  constructor(private http: HttpClient) {}

  public getTrackSkillDuplicates(): Observable<ISkillDuplicate[]> {
    const url = this.endpoint + `/GetTrackSkillDuplicates`;
    return this.http.get<ISkillDuplicate[]>(url, httpOptions);
  }

  public clearTrackSkillDuplicate(trackId: number, skillId: number): Observable<ISkillDuplicate> {
    const url = this.endpoint + `/ClearTrackSkillDuplicate?trackId=${trackId}&skillId=${skillId}`;

    return this.http.post<ISkillDuplicate>(url, httpOptions);
  }

  public clearTrackSkillDuplicates(): Observable<ISkillDuplicate> {
    const url = this.endpoint + `/ClearTrackSkillDuplicates`;
    return this.http.post<ISkillDuplicate>(url, httpOptions);
  }
}
